import { render, staticRenderFns } from "./PayoutResultPage.vue?vue&type=template&id=2ecf6a2a&scoped=true&"
import script from "./PayoutResultPage.vue?vue&type=script&lang=js&"
export * from "./PayoutResultPage.vue?vue&type=script&lang=js&"
import style0 from "./PayoutResultPage.vue?vue&type=style&index=0&id=2ecf6a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf6a2a",
  null
  
)

export default component.exports